import { bidRoles } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { getListForSelect } from "sources/books/usersGroups";

const config = {
    settings: {
        value: [],
        config: {
            isActive: {
                bWrapper: "row",
                inputProps: { name: "isActive" },
                checkbox: true,
            },
            commentRequired: {
                bWrapper: "row",
                inputProps: { name: "commentRequired" },
                checkbox: true,
            },
            bidRole: {
                inputProps: { name: "bidRole" },
                options: bidRoles,
            },
            hoursBefore: {
                inputProps: { name: "hoursBefore" },
                options: bidRoles,
            },
            groupId: {
                inputProps: { name: "groupId" },
                url: getListForSelect,
                propName: "name",
            },
            id: {},
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
